"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.onTheRoadArrivalTypeCustomChoices = void 0;
const conditionals = __importStar(require("../../common/conditionals"));
const customConditionals = __importStar(require("../../common/customConditionals"));
const helpers_1 = require("evolution-common/lib/services/odSurvey/helpers");
// FIXME This is copied from the `onTheRoadArrivalTypeChoices` type in
// choices.tsx. It was copied from there because a choice required the nickname
exports.onTheRoadArrivalTypeCustomChoices = [
    {
        value: 'home',
        label: (t) => t('visitedPlaces:onTheRoadArrivalTypeHome')
    },
    {
        value: 'usualWorkPlace',
        label: (t) => t('visitedPlaces:onTheRoadArrivalTypeUsualWorkPlace'),
        conditional: conditionals.onTheRoadUsualWorkplace
    },
    {
        value: 'other',
        label: (t) => t('visitedPlaces:onTheRoadArrivalTypeOther')
    },
    {
        value: 'stayedThereUntilTheNextDay',
        label: (t, interview, path) => {
            const activePerson = (0, helpers_1.getPerson)({ interview, path });
            const nickname = (activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname');
            return t('visitedPlaces:onTheRoadArrivalTypeStayedThereUntilTheNextDay', {
                nickname,
                count: (0, helpers_1.countPersons)({ interview })
            });
        },
        conditional: customConditionals.isLastPlaceCustomConditional
    }
];
